import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Converts a UTC timestamp to the user's local timezone and formats it
 * @param utcTimestamp - The UTC timestamp (ISO string or Date)
 * @param format - The format string for dayjs (default: 'MMMM D, YYYY [at] h:mm A')
 * @returns Formatted date string in user's local timezone
 */
export const formatTimestampToLocal = (utcTimestamp: string | Date, format: string = 'MMMM D, YYYY [at] h:mm A'): string => {
  return dayjs.utc(utcTimestamp).tz(dayjs.tz.guess()).format(format);
};

/**
 * Converts a UTC timestamp to the user's local timezone (dayjs object)
 * @param utcTimestamp - The UTC timestamp (ISO string or Date)
 * @returns dayjs object in user's local timezone
 */
export const convertToLocalTimezone = (utcTimestamp: string | Date): dayjs.Dayjs => {
  return dayjs.utc(utcTimestamp).tz(dayjs.tz.guess());
};

/**
 * Gets the user's timezone name
 * @returns The user's timezone (e.g., 'America/New_York')
 */
export const getUserTimezone = (): string => {
  return dayjs.tz.guess();
}; 